
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 15.901A7.9 7.9 0 01.099 8a7.9 7.9 0 017.9-7.901 7.9 7.9 0 017.902 7.9A7.9 7.9 0 018 15.902zM8 .89a7.107 7.107 0 00-7.111 7.11 7.24 7.24 0 00.948 3.556A7.903 7.903 0 018 8.592a7.843 7.843 0 016.163 2.963A6.982 6.982 0 0015.11 8c0-3.931-3.18-7.111-7.111-7.111zm0 6.913a2.774 2.774 0 01-2.766-2.765A2.774 2.774 0 018 2.27a2.774 2.774 0 012.765 2.766A2.774 2.774 0 018 7.802z","fill":"#fff"}})])
          )
        }
      }
    